import {gaConfig} from '@stencil/hotels-config';
import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
import EMIModalContent, {RequiredEmiRates} from '../../../../../shared/components/EMIModal';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import TriggerAnchorText from '../../../../../shared/components/TriggerActionText';
import {
  CenteredSpaceWrap,
  SmallSectionHeader,
  PrimaryLink,
} from '../../../CommonStyleUtils/dwebCommon.styles';
// CONFIG
import {rupeeString} from '../../../../../shared/config/app-config';
import GoSafeTagPersuasion from '../../../../../shared/pages/DetailsPage/components/HotelDetails/GoSafeTagPersuasion/GoSafeTagPersuasion';
import {
  ICityMetaInfo,
  IHotelData,
  ISrpConfig,
  ISRPHotelThumbnailImages,
} from '../../../../../shared/pages/SRP/redux/types';
import {splitRoomString} from '../../../../../shared/utils/room-string-utils';
import googleIcon from '../../../../assets/hotels/googleIcon.png';
// import RatingStarIcon from '../../../../Icons/RatingStarIcon';
// import RupeeIcon from '../../../../Icons/RupeeIcon';
import TripAdvisorIcon from '../../../../Icons/TripAdvisorIcon';
import SearchPageSoldOut from '../../DetailsPage/SoldOut/SearchPageSoldOut';
import OfferTag from '../../HomePage/SegmentSlider/OfferTagBlock/OfferTag';
import FreeBreakfastTag from '../FreeBreakfastTag/FreeBreakfastTag';
import HotelCardDealTag from '../HotelCardDealTag/HotelCardDealTag';
import HotelCardImageGallery from '../HotelCardImageGallery/HotelCardImageGallery';
import PersuasionHoverText from '../PersuasionHoverText/PersuasionHoverText';
import ReviewAndRatings from '../ReviewAndRatings/ReviewAndRatings';
import * as S from './HotelCard.styles';
import HotelCardPersuasionsBlock from './HotelCardPersuasionsBlock';
import ReserverNowPayLaterIcon from '../../../../Icons/ReserveNowPayLater';

import HappyRatingStarIcon from '@stencil/icons/src/HappyRatingStarIcon/HappyRatingStarIcon';
import HappyRupeeIcon from '@stencil/icons/src/HappyRupeeIcon/HappyRupeeIcon';

// CONFIG

const HotelCard = ({
  data,
  cityMetaInfo,
  roomString,
  srpConfig,
  navigateToDetailsPage,
  toggleSiginPopupCaller,
  isLoggedIn,
  country,
  staticLocationList,
  isMetaViewedHotel,
  isSearchedHotel,
  fetchSrpOfferDataThunkCaller,
  offerData,
  gaHandler,
  showLockAnimation,
  getSeoDetailsPageUrl,
  isSEO = false,
}: {
  data: IHotelData;
  cityMetaInfo: ICityMetaInfo;
  srpConfig: ISrpConfig;
  roomString: string;
  country: string;
  navigateToDetailsPage: Function;
  toggleSiginPopupCaller: Function;
  gaHandler: Function;
  fetchSrpOfferDataThunkCaller: Function;
  isLoggedIn: boolean;
  staticLocationList: {[K: string]: string};
  isMetaViewedHotel: boolean;
  isSearchedHotel: boolean;
  showLockAnimation: boolean;
  getSeoDetailsPageUrl: Function;
  isSEO: boolean;
}) => {
  const {
    t: imageLink,
    si: smallImageList = [],
    hi: hotelImages, // this will have both small(thumbnail) and main images
    oip: overImagePersuasion = [],
    tgi: tagIndex = [],
    opr: originalPricing = '',
    spr: currentPricing = '',
    do: displayOriginalPricing = 1,
    adp: additionalDiscountPricingAfterLogin = '',
    ofs: offersAppliedText,
    cbm: cashbackAmount = '',
    tnc = '',
    pxper = '',

    hr: hotelRatingCount = '',
    hn: hotelName = '',
    hc: hotelId,
    hti: hotelTypeIndex,
    l: location = '',
    rtn: roomTypeName = '',
    ami: amenitiesIndexApplicableForHotel,
    grc: ratingCount,
    rec: reviewCount,
    gr: hotelReview,
    gri: ratingType,
    rac: reviewRatingBreakup = [],
    rnpl: isRnpl = false,
    distl = [],
    lib: showMemberPrice = false,
    npp: goSafePersuasion = [],
    app: abovePricePersausion = [],
    bp: bannerPersuasion = [],
    bbp: belowBannerPersuasion = [],
    cp1: contentPersuasion1 = [],
    cp2: contentPersuasion2 = [],
    arp: aboveRatePlanPersuasion = [],
    bpp: belowPricePersuasion = [],
    pph,
    emi: emiStartingPrice,
    emid: emiRates,
    dspr: discountPriceAfterLogin,
  } = data;
  const {
    ata: tagTypesAvailable,
    gsm: gostaysPromises = [],
    aty: propertyTypeListMapping,
    am: amenitiesListMapping,
    dln,
  } = cityMetaInfo;

  const {metaPartner} = srpConfig;

  const {paxCount, childCount} = splitRoomString(roomString);
  const applicableTagTypes = tagIndex.map(item => tagTypesAvailable[item]);
  const isGoStays = applicableTagTypes.indexOf('Gostays') > -1;
  const isSoldOut = originalPricing === 0;
  const locationFilterObject = {
    location_search: [
      {
        id_type: 'voy',
        loc_id:
          staticLocationList && Object.keys(staticLocationList).length > 0
            ? staticLocationList[location]
            : '',
        n: location,
      },
    ],
  };

  let distanceTextArr = [];
  let distanceTextArrForDisplay = '';
  let spillOverDistanceTextArr = [];
  let spillOverDistanceTextArrForDisplay = '';
  if (distl && distl.length > 0) {
    distanceTextArr = distl
      .filter((item, index) => {
        if (index >= 1) spillOverDistanceTextArr[index] = {distanceText: item, locationText: ''};
        return index < 1;
      })
      .map(item => ({distanceText: item, locationText: ''}));
    dln &&
      dln.map((item, index) => {
        if (!item) return;
        if (!distanceTextArr[index] && spillOverDistanceTextArr[index]) {
          spillOverDistanceTextArr[index].locationText = item;
        } else {
          distanceTextArr[index].locationText = item;
        }
      });

    spillOverDistanceTextArr.map(item => {
      if (item) {
        spillOverDistanceTextArrForDisplay += `${item.distanceText} ${item.locationText} \n`;
      }
    });

    distanceTextArr.map(item => {
      if (item) {
        distanceTextArrForDisplay += `${item.distanceText} ${item.locationText}`;
      }
    });
  }

  const getMetaPartnerCallout = metaPartnerType => {
    switch (metaPartnerType) {
      case 'google':
        return (
          <S.MetaLandingWrapper width="16.6rem">
            <S.MetaLandingText>As seen on</S.MetaLandingText>
            <S.MetaWrappedImg src={googleIcon} />
          </S.MetaLandingWrapper>
        );

      default:
        return (
          <S.MetaLandingWrapper width={metaPartner === 'tripadvisor' ? '20.6rem' : '15.6rem'}>
            <S.MetaLandingText>As seen on {metaPartner}</S.MetaLandingText>
            {metaPartner === 'tripadvisor' && (
              <span>
                <TripAdvisorIcon height="3rem" width="3rem" />
              </span>
            )}
          </S.MetaLandingWrapper>
        );
    }
  };

  const getPriceBlock = () => {
    return (
      <>
        {(displayOriginalPricing && (
          <S.OriginalPriceTextWrapper>
            {/* <S.RupeeSymbolWrapDiv></S.RupeeSymbolWrapDiv> */}
            <span>₹{originalPricing}</span>
          </S.OriginalPriceTextWrapper>
        )) ||
          null}
        <S.CurrentPriceTextWrapper>
          {/* <S.RupeeSymbolWrapDiv> */}
          <HappyRupeeIcon fill={defaultTheme.colors.downriver.base} />
          {/* </S.RupeeSymbolWrapDiv> */}
          <S.CurrentPrice itemProp="priceRange">{currentPricing}</S.CurrentPrice>
        </S.CurrentPriceTextWrapper>
        {(tnc && <S.TaxPriceTextWrapper>+ ₹{tnc} taxes & fees</S.TaxPriceTextWrapper>) || null}
        <S.PerRoomNightTextWrapper>per room / night</S.PerRoomNightTextWrapper>
      </>
    );
  };

  return (
    <>
      <S.OuterWrapperDiv
        itemScope
        itemType="http://schema.org/Hotel"
        onClick={() => {
          navigateToDetailsPage();
        }}
      >
        {(isMetaViewedHotel && getMetaPartnerCallout(metaPartner)) || null}

        <S.WrapperSectionMetaDiv displayBorder={isMetaViewedHotel || isSearchedHotel}>
          {(bannerPersuasion &&
            bannerPersuasion.length > 0 &&
            bannerPersuasion.map(item => <HotelCardDealTag data={item} />)) ||
            null}

          <S.ImageGalleryWrapperDiv>
            {(overImagePersuasion &&
              overImagePersuasion.length > 0 &&
              overImagePersuasion.map((item, index) => (
                <React.Fragment key={'overImagePersuasion' + index}>
                  <FreeBreakfastTag text={item.pt} />
                </React.Fragment>
              ))) ||
              null}

            <HotelCardImageGallery
              data={hotelImages as Array<ISRPHotelThumbnailImages>}
              navigateToDetailsPage={navigateToDetailsPage}
              isGoStays={isGoStays}
              gostaysPromises={gostaysPromises}
              country={country}
            />
          </S.ImageGalleryWrapperDiv>

          <S.HotelCardInfoWrapperDiv isSoldOut={isSoldOut}>
            <S.HotelInfoWrapperDiv>
              <S.HeadingInfoWrapperDiv>
                <CenteredSpaceWrap>
                  <CenteredSpaceWrap>
                    {(hotelRatingCount && (
                      <span itemProp="starRating" content={hotelRatingCount}>
                        {[...Array(hotelRatingCount)].map((item, index) => (
                          <HappyRatingStarIcon key={'starIcon' + index} />
                        ))}
                      </span>
                    )) ||
                      null}
                    <S.HotelTypeTag>
                      {(hotelTypeIndex && propertyTypeListMapping[hotelTypeIndex]) || ''}
                    </S.HotelTypeTag>
                    {/* {(contentPersuasion2 && !!contentPersuasion2.length && (
                      <GoSafeTagPersuasion
                        data={contentPersuasion2[0]}
                        onCtaClick={navigateToDetailsPage}
                        gaHandler={gaHandler}
                      />
                    )) ||
                      null} */}
                    {/* <S.RoomTypeWrapperDiv>
                      {goSafePersuasion && !!goSafePersuasion.length &&
                        <PersuasionHoverText
                          data={goSafePersuasion}
                          actionHandler={(item, text) => {
                            item.utag[0].n = text;
                            navigateToDetailsPage(item);
                          }}
                          direction="bottom"
                          type="goSafePersuasion"
                          gaHandler={gaHandler}
                        /> || null}
                      </S.RoomTypeWrapperDiv> */}
                  </CenteredSpaceWrap>

                  <ReviewAndRatings
                    hotelReview={hotelReview}
                    reviewCount={reviewCount}
                    ratingCount={ratingCount}
                    ratingType={ratingType}
                    breakup={reviewRatingBreakup}
                  />
                </CenteredSpaceWrap>
                <S.HotelNameWrapperDiv>
                  {(isSEO && (
                    <S.HotelNameSeoAnchor
                      itemProp="name"
                      content={hotelName}
                      onClick={e => e.stopPropagation()}
                      target="_blank"
                      href={getSeoDetailsPageUrl()}
                    >
                      {hotelName}
                    </S.HotelNameSeoAnchor>
                  )) || (
                    <SmallSectionHeader
                      itemProp="name"
                      // onClick={() => {
                      //   navigateToDetailsPage();
                      // }}
                    >
                      {hotelName}
                    </SmallSectionHeader>
                  )}
                </S.HotelNameWrapperDiv>
                <div itemProp="address">
                  {location && (
                    <PersuasionHoverText
                      data={[
                        {
                          pt: location,
                          ccd: {tc: defaultTheme.colors.goBrandBlue.base, bgc: 'white'},
                          htd: {
                            h: location,
                            hoc: {bgc: defaultTheme.colors.goBrandBlue.medium},
                            hec: {tc: defaultTheme.colors.goBrandBlue.base, bgc: 'white'},
                            ht: [`Near ${location}`],
                            ft: `Show properties in ${location}`,
                            ic: 'tLocation',
                          },
                          fd: locationFilterObject,
                        },
                      ]}
                      direction="bottom-right"
                      actionHandler={() => {
                        navigateToDetailsPage(locationFilterObject, location);
                      }}
                      type="customLocation"
                      gaHandler={gaHandler}
                    />
                  )}
                  <span>
                    {distanceTextArr && distanceTextArr.length > 0 && (
                      <S.DistanceText>
                        {location && '|'} {distanceTextArrForDisplay}{' '}
                        {spillOverDistanceTextArrForDisplay &&
                          spillOverDistanceTextArrForDisplay.length && (
                            <S.ItemMoreWrap>
                              <S.ItemMoreText>...</S.ItemMoreText>
                              <S.ItemMoreList>{spillOverDistanceTextArrForDisplay}</S.ItemMoreList>
                            </S.ItemMoreWrap>
                          )}
                      </S.DistanceText>
                    )}
                  </span>
                </div>
                {/* <GoSafePersuasions /> */}
              </S.HeadingInfoWrapperDiv>

              {(!isSoldOut && (
                <HotelCardPersuasionsBlock
                  aboveRatePlanPersuasion={aboveRatePlanPersuasion}
                  navigateToDetailsPage={navigateToDetailsPage}
                  gaHandler={gaHandler}
                  roomTypeName={roomTypeName}
                  amenitiesIndexApplicableForHotel={amenitiesIndexApplicableForHotel}
                  amenitiesListMapping={amenitiesListMapping}
                  contentPersuasion1={contentPersuasion1}
                  contentPersuasion2={contentPersuasion2}
                />
              )) ||
                null}
            </S.HotelInfoWrapperDiv>

            {(!isSoldOut && (
              <S.HotelPricingInfoWrapperDiv>
                <S.ContentWrapperDiv>
                  {(belowBannerPersuasion && belowBannerPersuasion.length > 0 && (
                    <PersuasionHoverText
                      data={belowBannerPersuasion}
                      actionHandler={item => {
                        navigateToDetailsPage(item);
                      }}
                      type="belowBannerPersuasion"
                      gaHandler={gaHandler}
                    />
                  )) ||
                    null}

                  {(pxper && pxper > 1 && (
                    <S.PaxSplitWrapperDiv>
                      <S.PaxSplitTextWrapper>
                        {paxCount + childCount} GUESTS | {pxper} ROOMS
                      </S.PaxSplitTextWrapper>
                    </S.PaxSplitWrapperDiv>
                  )) ||
                    null}

                  {/* <S.TierLevelWrapperDiv>
                <S.TierLevelTextWrapper>Gold Level</S.TierLevelTextWrapper>
              </S.TierLevelWrapperDiv> */}
                </S.ContentWrapperDiv>
                <div>
                  <S.PriceInfoWrapperDiv>
                    <S.RoomTypeWrapperDiv>
                      {(abovePricePersausion && abovePricePersausion.length > 0 && (
                        <PersuasionHoverText
                          data={abovePricePersausion}
                          position={{
                            wrapperDiv: {
                              bottom: '2rem',
                              right: '0',
                            },
                            tip: {
                              bottom: '-0.2rem',
                              right: '15%',
                              transform: 'translate(-50%, 50%) rotate(45deg)',
                            },
                          }}
                          type="abovePricePersausion"
                          gaHandler={gaHandler}
                        />
                      )) ||
                        null}
                    </S.RoomTypeWrapperDiv>
                    {isLoggedIn && showMemberPrice && (
                      <>
                        <S.MemberPriceTag>Member Price!</S.MemberPriceTag>
                        <S.MemberPriceWrapDiv>{getPriceBlock()}</S.MemberPriceWrapDiv>
                      </>
                    )}

                    {(!isLoggedIn || !showMemberPrice) && getPriceBlock()}
                    {!!isRnpl && (
                      <S.BookNowPayLaterWrap>
                        <ReserverNowPayLaterIcon
                          fill={defaultTheme.colors.goTeal.dark}
                          width="2rem"
                          height="2rem"
                        />
                        <S.BookNowPayLaterText>Book Now, Pay Later</S.BookNowPayLaterText>
                      </S.BookNowPayLaterWrap>
                    )}
                    {(isLoggedIn && offersAppliedText && (
                      <OfferTag
                        cashbackText={cashbackAmount}
                        offerText={offersAppliedText}
                        offerData={(offerData && offerData[hotelId]) || null}
                        actionHandler={() => {
                          fetchSrpOfferDataThunkCaller({hotelId: hotelId, pph: pph});
                        }}
                      />
                    )) ||
                      null}

                    {(belowPricePersuasion && belowPricePersuasion.length > 0 && (
                      <S.RoomTypeWrapperDiv>
                        <PersuasionHoverText
                          data={belowPricePersuasion}
                          actionHandler={(item, text) => {
                            item.utag[0].n = text;
                            navigateToDetailsPage(item);
                          }}
                          direction="top"
                          type="belowPricePersuasion"
                          gaHandler={gaHandler}
                          hasMainTextIcon
                        />
                      </S.RoomTypeWrapperDiv>
                    )) ||
                      null}

                    <EMI emiStartingPrice={emiStartingPrice} emiRates={emiRates} />

                    {/* <SelectRoomButton
                    actionHandler={() => {
                      navigateToDetailsPage();
                    }}
                  /> */}
                  </S.PriceInfoWrapperDiv>
                  {(!isLoggedIn &&
                    ((!!discountPriceAfterLogin && currentPricing > discountPriceAfterLogin && (
                      <>
                        <S.SignUpLockOuterWrapper
                          onClick={e => {
                            e.stopPropagation();
                            toggleSiginPopupCaller(gaConfig.LoggedInPriceBenefitLabel);
                          }}
                        >
                          {/* {(additionalDiscountPricingAfterLogin && (
                        <S.BlueTextWrapper>
                          Login to save ₹ {additionalDiscountPricingAfterLogin} more
                        </S.BlueTextWrapper>
                      )) || <> */}
                          <S.SignUpTextWrap>Login & get at </S.SignUpTextWrap>
                          <S.SignUpPriceWrap>
                            <HappyRupeeIcon
                              height="1rem"
                              width="1rem"
                              fill={defaultTheme.colors.downriver.base}
                            />
                            {discountPriceAfterLogin}
                          </S.SignUpPriceWrap>
                          <S.SignUpPerNight> / night</S.SignUpPerNight>
                        </S.SignUpLockOuterWrapper>
                        {(showLockAnimation && (
                          <>
                            <S.LockBackground></S.LockBackground>
                            <S.SignUpLockWrapAnimated />
                          </>
                        )) || <S.SignUpLockWrap />}
                      </>
                    )) || (
                      <S.PriceInfoWrapperDiv>
                        <PrimaryLink
                          onClick={e => {
                            e.stopPropagation();
                            toggleSiginPopupCaller();
                          }}
                        >
                          Login for more deals
                          {/* <S.BlueTextWrapper>Login for more deals</S.BlueTextWrapper> */}
                        </PrimaryLink>
                      </S.PriceInfoWrapperDiv>
                    ))) ||
                    null}
                </div>
                {/* {!isLoggedIn &&
                !!discountPriceAfterLogin &&
                ((showLockAnimation && (
                  <>
                    <S.LockBackground></S.LockBackground>
                    <S.SignUpLockWrapAnimated />
                  </>
                )) || <S.SignUpLockWrap />)} */}
              </S.HotelPricingInfoWrapperDiv>
            )) || <SearchPageSoldOut />}
          </S.HotelCardInfoWrapperDiv>
        </S.WrapperSectionMetaDiv>
      </S.OuterWrapperDiv>
    </>
  );
};

export default React.memo(HotelCard);

const EMI = (emiData: {emiStartingPrice: string; emiRates: RequiredEmiRates}) => {
  const {
    isModalOpen: isEMIModalOpen,
    openModal: openEMIModal,
    closeModal: closeEMIModal,
  } = useModal();

  if (!(emiData.emiStartingPrice && emiData.emiRates)) {
    return null;
  }

  return (
    <S.EMIContainer>
      <TriggerAnchorText
        onClick={e => {
          e.stopPropagation();
          openEMIModal();
        }}
      >
        <S.EMITextWrapperDiv>
          {true && (
            <>
              <S.EMIWrap>EMI</S.EMIWrap>
              {/* <S.EMITextWrapper> */}
              No Cost | Starts@
              <S.EMITextPrice>
                {rupeeString}
                {emiData.emiStartingPrice}
              </S.EMITextPrice>
              {/* </S.EMITextWrapper> */}
            </>
          )}
        </S.EMITextWrapperDiv>
      </TriggerAnchorText>

      <Modal isOpen={isEMIModalOpen} closeModal={closeEMIModal}>
        <EMIModalContent emiRates={emiData.emiRates} />
      </Modal>
    </S.EMIContainer>
  );
};
